import HolderOutlined from '@ant-design/icons/lib/icons/HolderOutlined'
import { Button } from 'antd'
import { CSSProperties, FC, useContext } from 'react'
import { SortableRowContext } from './sortable-row'

interface SortableDragHandleProps {
    style?: CSSProperties
    className?: string
}

export const SortableDragHandle: FC<SortableDragHandleProps> = ({ style, className }) => {
    const { setActivatorNodeRef, listeners } = useContext(SortableRowContext)

    return (
        <Button
            type='text'
            size='small'
            icon={<HolderOutlined />}
            className={className}
            style={{ cursor: 'move', ...style }}
            ref={setActivatorNodeRef}
            {...listeners}
        />
    )
}
